const   TimeLineItem = (props) => {
    const { title, description, time, info, borderStyle } = props;

    return (
        <div className={`tg23-timeLineItem tg23-hidden ${borderStyle}`}>
            <div className="tg23-myTimeLine-box">
                <div className="tg23-myTimeLine">
                    <div className="tg23-info">
                        <div className="tg23-moreInfo underline">
                            More Info
                        </div>
                        {title ? <h2>{title}</h2> : <></>}
                        {description ? <p>{description}</p> : <></>}
                        {time ? <span>{time}</span> : <></>}
                    </div>
                    <div className="tg23-moreinfo flip">
                        <h2>{info}</h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimeLineItem;
